/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Hb1ac from './hb-1-ac';
import Hb1acDetail from './hb-1-ac-detail';
import Hb1acUpdate from './hb-1-ac-update';
import Hb1acDeleteDialog from './hb-1-ac-delete-dialog';

const Hb1acRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Hb1ac />} />
    <Route path="new" element={<Hb1acUpdate />} />
    <Route path=":id">
      <Route index element={<Hb1acDetail />} />
      <Route path="edit" element={<Hb1acUpdate />} />
      <Route path="delete" element={<Hb1acDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default Hb1acRoutes;
